// Central SEO configuration. Update SITE.url to the live domain before deploy.
export const SITE = {
  name: "Gapsmiths Consulting LLP",
  shortName: "Gapsmiths",
  url: "https://gapsmiths.com",
  defaultTitle: "Gapsmiths Consulting LLP — a builder's studio",
  defaultDescription:
    "Gapsmiths is a builder's studio in Mumbai. We work out what's wrong, build what fixes it, and run our own products.",
  ogImage: "/og-image.svg",
  locale: "en_IN",
  twitter: "",
};
